import type { SurfaceId } from 'src/types/banner-views';

/** Cury diffuser third-party app promo (device drawer). */
export const CURY_APP_PROMO_BANNER_ID = 'cury-app-promo';
export const CURY_APP_PROMO_SURFACE = 'device-drawer';
export const CURY_APP_PROMO_CTA_GO_TO_APP = 'go-to-app';

/** Legacy localStorage key — migrated once into banner_views. */
export const CURY_APP_PROMO_LEGACY_LS_KEY = 'cury_app_promo_dismissed';

/** Verivox setup / offers banners (multi-surface). */
export const VERIVOX_SETUP_BANNER_ID = 'verivox-setup';
export const VERIVOX_OFFERS_BANNER_ID = 'verivox-offers';
export const VERIVOX_CTA_OPEN_SETUP = 'open-setup';

export const VERIVOX_SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;

/** Camera Cloud Storage promo on camera device side panels / drawers. */
export const CAMERA_CLOUD_STORAGE_PROMO_BANNER_ID = 'camera-cloud-storage-promo';
export const CAMERA_CLOUD_STORAGE_PROMO_SURFACE = 'device-side-panel';
/** Production hide duration after dismiss (one month). */
export const CAMERA_CLOUD_STORAGE_PROMO_SNOOZE_MS = VERIVOX_SNOOZE_MS;
/** Short hide so repo QA can re-show the banner without waiting a month. */
export const CAMERA_CLOUD_STORAGE_PROMO_SNOOZE_MS_QA = 60 * 1000;

export function getCameraCloudStoragePromoSnoozeMs(useQaSnooze: boolean): number {
	return useQaSnooze ? CAMERA_CLOUD_STORAGE_PROMO_SNOOZE_MS_QA : CAMERA_CLOUD_STORAGE_PROMO_SNOOZE_MS;
}

export type VerivoxBannerSurface =
	| 'consumption'
	| 'notifications'
	| 'energyDashboard'
	| 'customDashboard'
	| 'roomsList';

export const VERIVOX_BANNER_SURFACES: readonly VerivoxBannerSurface[] = [
	'consumption',
	'notifications',
	'energyDashboard',
	'customDashboard',
	'roomsList',
] as const;

export const isVerivoxBannerSurface = (surface: SurfaceId): surface is VerivoxBannerSurface =>
	(VERIVOX_BANNER_SURFACES as readonly string[]).includes(surface);
